var VARIANTS = {
  ARHI: "payment frequency"
};
var options = ["Weekly", "Fortnightly", "Monthly", "Quarterly", "HalfYearly", "Yearly"];
var validPaymentFrequency = function validPaymentFrequency(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var supportedOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : options;
  var error; // eslint-disable-line init-declarations
  if (!supportedOptions.includes(value || "")) {
    error = "Please choose your preferred ".concat(fieldName || VARIANTS[funnel] || VARIANTS.ARHI, ".");
  }
  return error;
};
export default validPaymentFrequency;